import { ReactElement, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getAds, Ad } from './util/advertisement';
import { usePanelLoading } from '@/components/PanelLoadingBoundary';

/**
 * 広告コンポーネント
 * @returns {ReactElement} 広告コンテンツ
 */
function Advertisement(): ReactElement {
    const { i18n } = useTranslation();
    const availableAds = useMemo(() => getAds(i18n.language), [i18n.language]);
    const [selectedAd, setSelectedAd] = useState<Ad | null>(null);
    const { setLoading } = usePanelLoading();

    useEffect(() => {
        if (availableAds.length > 0) {
            setSelectedAd(
                availableAds[Math.floor(Math.random() * availableAds.length)] ?? availableAds[0]
            );
        } else {
            setSelectedAd(null);
        }
        setLoading(false);
    }, [availableAds, setLoading]);

    const adHtml = selectedAd ?? availableAds[0] ?? '';

    return (
        <>
            {/* 広告 */}
            <div
                dangerouslySetInnerHTML={{ __html: adHtml }}
                className="w-full h-full overflow-hidden flex flex-col justify-center items-center px-4"
            />
        </>
    );
}

export default Advertisement;
